const _excluded = ["children", "onDragEnter", "onDragLeave", "onDropAccepted", "onDropRejected", "className", "accept", "classNameChildren", "error", "dataTestId"];
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.includes.js";
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import Dropzone from 'react-dropzone';
import clsx from 'clsx';
import { allMimeTypes, defaultAcceptMimeTypes } from "./drop-zone.vm";
import "./drop-zone-file.style.scss";
export const DropZoneFileChildren = props => {
  const {
    state,
    children,
    highlight,
    className,
    classNameChildren,
    error,
    dataTestId
  } = props;
  const {
    getRootProps,
    getInputProps,
    isDragActive,
    isDragAccept,
    isDragReject
  } = state;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", _extends({
    className: clsx('drop-zone-file-container', className, {
      'drop-zone-file-container-error': error
    })
  }, getRootProps()), /*#__PURE__*/React.createElement("input", _extends({}, getInputProps(), {
    "data-test-id": dataTestId
  })), /*#__PURE__*/React.createElement("div", {
    className: clsx('highlight-container', {
      'highlight-active': isDragActive && !isDragAccept && !isDragReject,
      'highlight-accept': isDragAccept,
      'highlight-reject': isDragReject,
      'highlight-enabled': highlight
    })
  }), /*#__PURE__*/React.createElement("div", {
    className: clsx('drop-zone-file-children', classNameChildren)
  }, children && children(state))));
};
export const DropZoneFile = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
      children,
      onDragEnter,
      onDragLeave,
      onDropAccepted,
      onDropRejected,
      className,
      accept,
      classNameChildren,
      error,
      dataTestId
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  const [highlight, setHighlight] = React.useState(false);
  const accepted = React.useMemo(() => {
    if (!accept) return defaultAcceptMimeTypes;
    if (typeof accept === 'string' && accept === allMimeTypes) {
      return undefined;
    } else if (accept.includes(allMimeTypes)) {
      return undefined;
    }
    return accept;
  }, [accept]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Dropzone, _extends({
    ref: ref,
    noClick: true,
    noKeyboard: true,
    onDragEnter: e => {
      onDragEnter && onDragEnter(e);
      setHighlight(true);
    },
    onDragLeave: e => {
      onDragLeave && onDragLeave(e);
      setHighlight(false);
    },
    onDropAccepted: (files, e) => {
      onDropAccepted && onDropAccepted(files, e);
      setHighlight(false);
    },
    onDropRejected: (files, e) => {
      onDropRejected && onDropRejected(files, e);
      setHighlight(false);
    },
    accept: accepted
  }, rest), state => /*#__PURE__*/React.createElement(DropZoneFileChildren, {
    state: state,
    highlight: highlight,
    children: children,
    className: className,
    classNameChildren: classNameChildren,
    error: error,
    dataTestId: dataTestId
  })));
});